export const getProjetos = (state) => state.projetos.lista
export const getTotalProjetos = (state) => state.projetos.total
export const getIsCarregandoListaProjetos = (state) => state.projetos.isCarregandoLista
export const getProjetoSelecionado = (state) => state.projetos.selecionado
export const getIsCarregandoProjetos = (state) => state.projetos.isCarregandoProjetos
export const getIsSavingProjetos = (state) => state.projetos.isSaving
export const getQuantidadeAcoesEmpresa = (state) => state.projetos.quantidadeAcoesEmpresa
